import { FC, ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import PerSpacer from '../../../components/custom_components/Spacer'
import { SalaryHistoryTable } from '../../profile/contract/SalaryHistoryTable'
import { BonusHistoryTable } from '../../profile/contract/BonusHistoryTable'
import { PerCollapse } from '../../../components/custom_components/Collapse'
import { NationalContractLevelHistoryTable } from '../../profile/contract/NationalContractLevelHistoryTable'
import { LevelHistoryTable } from '../../profile/contract/LevelHistoryTable'
import { PaymentHistoryTable } from '../../profile/contract/PaymentHistoryTable'
import { useAuth } from '../../../context/auth-context'
import { GovernmentJobTitleHistoryTable } from '../../profile/contract/GovernmentJobTitleHistoryTable'

interface Props {
  employeeId: string
  isMonthlySalaryDisplayed: boolean
  monthlySalaryMonthsInYear: number
  employeeTimezone: string
}

export const AppraisalContractHistory: FC<Props> = ({
  employeeId,
  employeeTimezone,
  isMonthlySalaryDisplayed,
  monthlySalaryMonthsInYear,
}) => {
  const { t } = useTranslation()
  const { user } = useAuth()
  const timezone = {
    locale: user.locale,
    timezone: employeeTimezone,
  }

  const renderHistoryTables = (table: ReactNode, noMargin?: boolean) => <PerSpacer mt={noMargin ? undefined : 'l'}>{table}</PerSpacer>

  return (
    <>
      <PerSpacer my="m">
        <PerCollapse
          panels={[
            {
              heading: t('appraisalMeeting.contract.contractHistory'),
              content: (
                <>
                  {renderHistoryTables(
                    <SalaryHistoryTable
                      employeeId={employeeId}
                      timezone={timezone}
                      isMonthlySalaryDisplayed={isMonthlySalaryDisplayed}
                      monthlySalaryMonthsInYear={monthlySalaryMonthsInYear}
                      noDivider
                    />,
                    true,
                  )}
                  {renderHistoryTables(<BonusHistoryTable employeeId={employeeId} timezone={timezone} noDivider />)}
                  {renderHistoryTables(<GovernmentJobTitleHistoryTable employeeId={employeeId} timezone={timezone} noDivider />)}
                  {renderHistoryTables(<NationalContractLevelHistoryTable employeeId={employeeId} timezone={timezone} noDivider />)}
                  {renderHistoryTables(<LevelHistoryTable employeeId={employeeId} timezone={timezone} noDivider />)}
                  {renderHistoryTables(<PaymentHistoryTable employeeId={employeeId} timezone={timezone} noDivider />)}
                </>
              ),
            },
          ]}
        />
      </PerSpacer>
    </>
  )
}
